import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

interface CheckBoxProps {
  checked: boolean;
  onChange: () => void;
  className?: () => void;
}

const CheckBox = (props: CheckBoxProps) => {
  const { checked, onChange, className = '' } = props;
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      className={`lifepack-checkbox ${className}`}
    />
  );
};

export { CheckBox };
